import { render, staticRenderFns } from "./CheckboxWrapped.vue?vue&type=template&id=ff64c448&"
import script from "./CheckboxWrapped.vue?vue&type=script&lang=js&"
export * from "./CheckboxWrapped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports